export const create = {
  createSuccessfully: 'Create new machine part successfully!',
  createFailed: 'Create new machine part failed!',
}
